module.exports = __webpack_public_path__ + "img/dirty_floor.6cfddef3.svg";